import { memoize } from '@energywebfoundation/generic-green-proofs-common';
import type { QueryCache } from '@tanstack/react-query';
import { z } from 'zod';

declare global {
  interface Window {
    __MULTI_MODAL_CONFIG__?: unknown;
  }
}

const multiModalConfigSchema = z.object({
  baseApiUrl: z.url().optional(),
  hideHeader: z.boolean().optional(),
  headerOffset: z.number().optional(), // Height in px of the MMR's fixed header
  safcUrl: z.url({ protocol: /^https?$/ }).optional(),
  cookiePrefix: z.string().optional(), // For now it is optional, because this addition has to land first, and only then MMR with rewriting cookie names can be deployed
  // Typed only, not validated
  queryCache: z.custom<QueryCache>().optional(),
}).optional();

export type MultiModalConfig = NonNullable<z.infer<typeof multiModalConfigSchema>>;

export const getMultiModalConfig = memoize((): MultiModalConfig | undefined => {
  const result = multiModalConfigSchema.safeParse(window.__MULTI_MODAL_CONFIG__);
  if (!result.success) {
    throw new Error(`Invalid __MULTI_MODAL_CONFIG__:\n${z.prettifyError(result.error)}`);
  }
  return result.data;
});
